import { Heading, Icon } from '@assembly-js/design-system';

export const NoMessagesEmptyState = () => (
  <div className="box-border flex justify-center items-center relative w-full h-full">
    <div className="flex flex-col items-baseline max-w-[502px] mb-[34px]">
      <div className="flex items-center justify-center rounded-4 bg-slate-100 w-10 h-10 mb-3">
        <Icon icon="Message" className="w-5 h-5 text-gray-small" />
      </div>
      <Heading className="leading-[30px] text-black-heading" size="2xl">
        No messages yet
      </Heading>
    </div>
  </div>
);
